/*

  Implementation by Amit Sharma
  Dated : 11/25/2019

*/

//import React from "react";
import axios from "axios";
//import { ajax } from 'rxjs/ajax';
import { from, of } from "rxjs";
import { map, catchError, first } from 'rxjs/operators';
import queryString from "query-string";
import {netDomain} from '../../homepage/services/SeekerServices';

const BASE_URL = "/ectools/api/";
const DEFAULT_FAILURE_MESSAGE = { "response": "failure", "message": "" }; // default failure message.


/* Implementation By: Amit Sharma | Method to post request to register New Employer */
export const freeRegistrationCredentials = (queryObject) => {
  if (!queryObject) {
    return of({ ...DEFAULT_FAILURE_MESSAGE, "message": "Enter registration details." });
  }
  return from(
    axios.get(netDomain + BASE_URL + 'freeRegistration/user/create?' + queryString.stringify(queryObject))
  ).pipe(
    first(),
    map(response => {
      if (response && response.data) {
        return response.data;
      } else

        // todo: BP -- response getting this if 404 (NotFound)
        return { ...DEFAULT_FAILURE_MESSAGE, "message": "Registration failed." }
    }),
    catchError((err) => { console.log(err); return of({ ...DEFAULT_FAILURE_MESSAGE, "message": "Failed to register" }) })
  );
};

/* Implementation By: Amit Sharma | Method to post request to register New Employer Details*/
export const freeRegistrationDetails = (queryObject) => {
  if (!queryObject) {
    return of({ ...DEFAULT_FAILURE_MESSAGE, "message": "Enter registration details." });
  }
  return from(
    axios.get(BASE_URL + 'freeRegistration/user/details?' + queryString.stringify(queryObject))
  ).pipe(
    first(),
    map(response => {
      if (response && response.data) {
        return response.data;
      } else
        return { ...DEFAULT_FAILURE_MESSAGE, "message": "Registration failed." }
    }),
    catchError((err) => { console.log(err); return of({ ...DEFAULT_FAILURE_MESSAGE, "message": "Failed to register" }) })
  );
}

/* Implementation By: Amit Sharma on 12/3/2019| Method to post job details during free registeration */
export const freeRegistrationJob = (params) => {
  if (!params) {
    return of({ ...DEFAULT_FAILURE_MESSAGE, "message": "Enter job details." });
  }
  const formData = new FormData();
  for (let key in params) {
    formData.append(key, params[key]);
  }
  return from(
    axios.post(BASE_URL + 'job/freeSave', formData)
  ).pipe(
    first(),
    map(response => {
      if (response && response.data) {
        return response.data;
      } else
        return { ...DEFAULT_FAILURE_MESSAGE, "message": "Job post failed." }
    }),
    catchError((err) => { console.log(err); return of({ ...DEFAULT_FAILURE_MESSAGE, "message": "Failed to post job" }) })
  );
}

/*

  Implementation from Taran Sahota
  Method to login into the employer section

  Makes API call
  receives JWT token
  and saves it inside local storage and redirects to EMPL app

*/
export const logInUser = (params) => {
  if (!params || !params.username || !params.password) {
    return of({ "response": "failure", "message": "Enter login details." });
  }
  if (params.rememberMe && params.rememberMe === true) {
    params['remember-me'] = params.rememberMe;
  } else {
    params['remember-me'] = false;
  }

  return from(
    axios({
      method: "POST",
      url: "/ectools/auth/apilogin", // for the API based login
      // url: "/ectools/auth/login",
      data: queryString.stringify(params),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
        "Access-Control-Allow-Origin": "*",
        "rememberMe": params.rememberMe
      }
    })
  ).pipe(
    first(),
    map((response) => {
      if (response.data && response.data.token) {
        localStorage.setItem("token", response.data.token);
        return { "response": "success", "message": response.data.token }
      } else {
        localStorage.removeItem("token");
        const err = response.data.error;
        switch (err) {
          case 'pending_review':
            return { "response": "failure", "message": "Your account is pending review by our Quality Assurance team.<br>You will receive an email once your account has been reviewed." };
          case 'pending_verification':
            return { "response": "failure", "message": "verification_failure", "vt": response.data.vt };
          case 'username_password':
            return { "response": "failure", "message": "Please check the email and password you entered." };
          default:
            return { "response": "failure", "message": "Please check the email and password you entered." };
        }
        // if (response.data && response.data.indexOf("Please check the email and password you entered") > -1) {
        //   return { "response": "failure", "message": "Please check the email and password you entered." };
        // } else if (response.data && response.data.indexOf("Your account is pending review by our Quality Assurance team") > -1) {
        //   return { "response": "failure", "message": "Your account is pending review by our Quality Assurance team.<br>You will receive an email once your account has been reviewed." };
        // } else if (response.data && response.data.indexOf(" to begin posting jobs.") > -1) {
        //   return { "response": "failure", "message": "verification_failure", "vt": getVt(response.data) };
        // } else {
        //   return { "response": "failure", "message": "Please check the email and password you entered." };
        // }
      }
    }),
    catchError((err) => { console.log(err); return of({ "response": "failure", "message": "Try again." }) })
  )
}

export const fetchUserDetails = () => {
  return from(
    axios({
      method: "GET",
      url: "/ectools/api/user/getDetails", // for the API based login
      config: {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
          "Access-Control-Allow-Origin": "*",
          'authorization': "Bearer " + localStorage.getItem("token")
        }
      }
    })
  ).pipe(
    first(),
    map((response) => {
      if (response.data && response.data.user) {
        return { "response": "success" }
      } else {
        return of({ "response": "failure" });
      }
    }),
    catchError((err) => { console.log(err); return of({ "response": "failure", "message": "Try again." }) })
  )
}

export const employerResetPassword = (params) => {
  if (!params.username) {
    of({ "response": "failure", "message": "Enter username to reset password." });
  }
  params["run"] = "yes";
  return from(
    axios({
      method: "POST",
      url: "/ectools/auth/forgotPassword",
      data: queryString.stringify(params)
    })
  ).pipe(
    first(),
    map((response) => {
      console.log("Data: " + JSON.stringify(response));
      if (response.data && response.data.indexOf("Your password reset email was sent.") > -1) {
        return { "response": "success", "message": "You should receive a password reset email in the next 15 minutes." }
      } else {
        return { "response": "failure", "message": "Invalid Email." }
      }
    }),
    catchError((err) => { console.log(err); return of({ "response": "failure", "message": "Please try again." }) })
  )
}
/*

  Taran Sahota
  Handles submit of the NEW PASSWORD form from the employer
  takes in
    id = user id -  comes through the url
    token =  app generated token - comes through the url
    password = new password entered by the user;

*/
export const employerResetPasswordConfirm = (params) => {
  if (!params.id || !params.token) {
    of({ "response": "failure", "message": "Invalid information for user password reset." });
  }
  return from(
    axios({
      method: "POST",
      url: "/ectools/auth/resetPassword",
      data: queryString.stringify(params)
    })
  ).pipe(
    first(),
    map((response) => {
      console.log("Data: " + JSON.stringify(response));
      if (response.data && (response.data.indexOf("Error!") > -1)) {
        return { "response": "failure", "message": "Error reseting password. Please try again." }
      } else if (response.data.indexOf("Sorry, we have no record of that request, or it has expired.") > -1) {
        return { "response": "failure", "message": "Sorry, we have no record of that request, or it has expired." }
      } else {
        return { "response": "success", "message": "Password reset successfully. Login again with your new password." }
      }
    }),
    catchError((err) => { console.log(err); return of({ "response": "failure", "message": "Error reseting password. Please try again." }) })
  )
}

export const submitVerificationDocuments = (params) => {
  return from(
    axios({
      method: "POST",
      url: "/ectools/account/review",
      data: params
    })
  ).pipe(
    first(),
    map((response) => {
      if (response.data && response.data.response === "success") {
        return { "response": "success" }
      } else {
        return { "response": "failure" }
      }
    }),
    catchError((err) => { console.log(err); return of({ "response": "failure" }) })
  )
}
